export default __webpack_public_path__ + "static/media/Vinidex 1.6 ratio (1).cf95544a.png";